'use client';

import { Banner } from '@medprev-web-app/api-graphql-client';
import { useParams, useRouter } from 'next/navigation';
import { useState } from 'react';
import { useStore } from 'zustand';

import { useNavigation } from '@/hooks/navigation/use-navigation.hook';
import { getAnalyticsPlugin } from '@/app/(main)/_components/logger/analytics/get-analytics-plugin';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';
import { userLocationStore } from '@/store/user-location.store';

interface BannerSheetProps {
  modalTitle: string | null;
  modalDescription: string | null;
  modalButtonText: string | null;
  onConfirm: () => void;
}

export function useBannerSheet() {
  const router = useRouter();
  const { resolveHref } = useNavigation();
  const analytics = getAnalyticsPlugin();
  const { slug } = useParams();
  const userLocation = useStore(
    userLocationStore,
    (state) => state.userLocation,
  );

  const [isBannerSheetOpen, setBannerSheetOpen] = useState(false);
  const [bannerSheetProps, setBannerSheetProps] = useState<BannerSheetProps>({
    modalTitle: '',
    modalDescription: null,
    modalButtonText: null,
    onConfirm: () => {},
  });

  const handleTrackAnalytics = (item: Banner) => {
    const isInCityPage = Boolean(slug);

    analytics.track(AnalyticsEnum.CLICK_BANNER, {
      banner_id: item.id,
      banner_nome: item.modalTitle,
      pagina: isInCityPage ? 'cidade' : 'home',
      cidade: userLocation?.city ? `${userLocation.city}-${userLocation.state}` : undefined,
    });
  };

  const handleBannerClick = (item: Banner) => {
    handleTrackAnalytics(item);

    const {
      modalTitle,
      modalDescription = '',
      modalButtonText = '',
      actionModalButton,
      actionOnBannerClick,
    } = item;

    if (actionOnBannerClick) {
      router.push(resolveHref(actionOnBannerClick));
      return;
    }

    if (!modalTitle) {
      return;
    }

    setBannerSheetOpen(true);
    setBannerSheetProps({
      modalTitle,
      modalDescription,
      modalButtonText,
      onConfirm: () => {
        if (actionModalButton) {
          router.push(resolveHref(actionModalButton));
        } else {
          setBannerSheetOpen(false);
        }
      },
    });
  };

  return {
    isBannerSheetOpen,
    setBannerSheetOpen,
    bannerSheetProps,
    handleBannerClick,
  };
}
